import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface UseZohoWidgetProps {
  showGoUpButton?: boolean;
  hasBottomNav?: boolean;
}

export function useZohoWidget({
  showGoUpButton = false,
  hasBottomNav = false,
}: UseZohoWidgetProps = {}) {
  const [isMobile, setIsMobile] = useState(() => {
    // Initialize with current window size if available
    return typeof window !== "undefined" ? window.innerWidth < 768 : false;
  });
  const location = useLocation();

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      const isMobileScreen = window.innerWidth < 768;
      setIsMobile(isMobileScreen);
    };

    // Check initially
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Determine if the widget should be shown on current page
  const shouldShowWidget = () => {
    const hiddenPaths = ["/get-started", "/login", "/register", "/signup", "/verify", "/onboarding", "/setup"];
    return !hiddenPaths.some((path) => location.pathname.startsWith(path));
  };

  return {
    isMobile,
    shouldShowWidget: shouldShowWidget(),
    showAboveGoUpButton: showGoUpButton && shouldShowWidget(),
    hasBottomNav: hasBottomNav && isMobile,
  };
}
